<template lang="html">
  <div>
    <v-container
      v-if="loading"
      style="height: 150px;"
    >
      <v-row
        class="fill-height"
        align="center" 
        justify="center"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-row>     
    </v-container>
    <v-form 
      v-else
    >
      <v-container>
        <v-row>
          <v-col 
            cols="12" 
          >
            <v-autocomplete
              v-model="newSuperior"
              v-validate="'required'"
              :items="employees"
              :error-messages="errors.collect('newSuperior')"
              data-vv-name="newSuperior"
              data-vv-as="superior"
              item-text="person.name"
              item-value="employee_uid"
              label="New Superior"
            />
          </v-col>
        </v-row>

        <v-card-actions>
          <v-spacer />
          <v-btn 
            :disabled="progressing || draftProgressing"
            text
            @click="closeDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            :disabled="progressing || draftProgressing"
            text
            @click="goPrevious"
          >
            Go back
          </v-btn>
          <v-btn
            :disabled="!newSuperior || progressing"
            :loading="draftProgressing"
            color="hrissecondary"
            class="white--text"
            @click="saveAsDraft"
          >
            Save
          </v-btn>          
          <v-btn
            :disabled="!newSuperior || draftProgressing"
            :loading="progressing"
            color="hrissecondary"
            class="white--text"
            @click="goNext"
          >
            Next
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-form>
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new',
    },
    props: {
      step: {
        type: Number,
        required: true,
      },
    },
    data: () => ({
      loading: false,
      progressing: false,
      employees: [],
      newSuperior: null,
      draftProgressing: false,
    }),
    watch: {
      step: function (val) {
        if (val === 2 && this.employees.length <= 0) {
          this.loadEmployees()
        }
      },
    },
    mounted () {
      this.loadEmployees()
    },
    methods: {
      loadEmployees () {
        this.loading = true
        
        this.$api.hrisEmployees().list('?with=vessel')
          .then((res) => {
            this.employees = res.data
            this.loading = false
          })
      },
      goPrevious () {
        this.$emit('previous-step')
      },
      goNext () {
        this.$validator.validateAll().then((result) => {
          if (!result) return

          this.$emit('next-step')
        })
      },
      getFormData () {
        return {
          assigned_to: this.newSuperior,
          new: true,
        }
      },
      resetData () {
        this.newSuperior = null
        this.employees = []

        this.$validator.reset()
      },
      saveAsDraft () {
        this.draftProgressing = true
        this.$emit('save-as-draft')
      },
      closeDialog () {
        this.$emit('close-dialog')
      },
    },

  }
</script>
